import { useTranslation } from "next-i18next";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { Stack } from "@chakra-ui/react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { QuantumHistoryView, QuantumMainView, useQuantumPageViews } from "@looksrare/classic-games/quantum";
import { getCanonicalAndLanguageAlternates, getChainInfo } from "@/utils";
import { Page } from "@/components";
import { YoloGamesQuantumProvider } from "@/components/YoloGamesQuantumProvider";

const QuantumMainPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  // Ensure that the page view is tracked
  useQuantumPageViews();

  const title = "Quantum";
  const description = "Pick your number, then aim to hit over or under it. Guess correctly to win.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/quantum/",
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={t("Quantum")} contentContainerProps={{ px: 4, py: 4 }}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/quantum/meta.png`,
              alt: "Quantum",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <YoloGamesQuantumProvider>
        <Stack spacing={8} width="100%" pb={{ base: 20, xl: 4 }}>
          <QuantumMainView />

          <QuantumHistoryView />
        </Stack>
      </YoloGamesQuantumProvider>
    </Page>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["quantum", "common", "localization"])),
    },
  };
};

export default QuantumMainPage;
